/**
 * Whether a localization namespace has finished loading, probed via one of its labels.
 *
 * `useLocalization` is SWR-backed, and until it resolves `getLocalizationProxy` returns
 * `''` from every `.t()` call rather than throwing or signalling. That makes the EDD
 * labels render half-built: values that are not localized — the store name, the
 * formatted date — paint immediately while every surrounding phrase is still blank.
 *
 * Because the proxy is empty as a whole until the fetch lands, any single label answers
 * for the namespace. Probe one that always has a value (all `Availability.labels`
 * entries do, in both locales) so a legitimately blank translation cannot be mistaken
 * for a pending fetch.
 */
export const hasLoadedLabel = (label: { t: () => string }): boolean => !!label.t();
